export enum GroupTypeEnum {
  Attachment = 'attachment',
  Date = 'date',
  Results = 'result',
  LabTemplate = 'labTemplate',
  FlowSheet = 'flowSheet'
}

export enum TestTypeValuesEnum {
  TestItems = 'testItems',
  LabTemplatesByLoinc = 'labTemplatesByLoinc',
  TestItemsByMappingOrLonic = 'testItemsByMappingOrLonic'
}


export enum FilterConfigEnum {
  IncludeCancelled = 'includeCancelled',
  IncludeStrikeouts = 'includeStrikeouts',
}
